import React from "react";

export default ({ color }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24">
    <path fill={color} d="M18,18H6V6H18V18Z" />
  </svg>
);
